export const en = {
  FAQs: {
    'Order & Shipping': 'Order & Shipping',
    'Exchange & Return': 'Exchange & Return',
    'How long will it take to receive my order?': 'How long will it take to receive my order?',
    "<p>Typically, it takes 3-5 business days to receive your order. We're doing our best to deliver it promptly for you.</p>":
      "<p>Typically, it takes 3-5 business days to receive your order. We're doing our best to deliver it promptly for you.</p>",
    'How to track my order?': 'How to track my order?',
    '<p>Please track your order at our Tracking page <a href="https://17track.net/en" rel="noopener noreferrer" target="_blank">https://17track.net/en</a></p>':
      '<p>Please track your order at our Tracking page <a href="https://17track.net/en" rel="noopener noreferrer" target="_blank">https://17track.net/en</a></p>',
    'Do you ship internationally?': 'Do you ship internationally?',
    '<p>Yes, we do ship internationally. The shipping fee may vary depending on your location.</p>':
      '<p>Yes, we do ship internationally. The shipping fee may vary depending on your location.</p>',
    'I never got my order, what to do?': 'I never got my order, what to do?',
    '<p>Please make sure you tracked your order from our Tracking page. Or call us at hotline: 123456XXX</p>':
      '<p>Please make sure you tracked your order from our Tracking page. Or call us at hotline: 123456XXX</p>',
    'What is your return policy?': 'What is your return policy?',
    '<p>Please check our return/refund/exchange policy <a href="https://{{shopifyDomain}}/policies/refund-policy" rel="noopener noreferrer" target="_blank">here</a>.</p>':
      '<p>Please check our return/refund/exchange policy <a href="https://{{shopifyDomain}}/policies/refund-policy" rel="noopener noreferrer" target="_blank">here</a>.</p>',
    'Can I exchange an item?': 'Can I exchange an item?',
    '<p>You can exchange an item with a higher-price item or the same item with a different size. See detailed policy <a href="https://{{shopifyDomain}}/policies/refund-policy" rel="noopener noreferrer" target="_blank">here</a>.</p>':
      '<p>You can exchange an item with a higher-price item or the same item with a different size. See detailed policy <a href="https://{{shopifyDomain}}/policies/refund-policy" rel="noopener noreferrer" target="_blank">here</a>.</p>'
  },
  'FAQ page': {
    Heading: 'Frequently Asked Questions',
    Description: 'Got a question? We are here to answer!',
    'FAQ page search placeholder': 'Type keyword to find your answer',
    '"All" tabs in FAQ page': 'All',
    '"No matching article found" message': 'No matching article found',
    'Articles label': 'articles',
    'Article label': 'article',
    'Contact section heading': 'Not finding what are you looking for?',
    'Contact section description': 'Chat with us or send us an email',
    'Contact button text': 'Contact us',
    'No matching articles found': 'No matching articles found'
  },
  'Suggested FAQ': {
    '🛒 Track my order': '🛒 Track my order',
    '<p>You can track your order using the tracking number provided in your shipping confirmation email. Click on <a href="#chatty-tracking">Track</a> navigation&nbsp;</p>':
      '<p>You can track your order using the tracking number provided in your shipping confirmation email. Click on <a href="#chatty-tracking">Track</a> navigation&nbsp;</p>',
    '🚚 How long does delivery take?': '🚚 How long does delivery take?',
    "<p>Typically, it takes 3-5 business days to receive your order. We're doing our best to deliver it promptly for you.</p>":
      "<p>Typically, it takes 3-5 business days to receive your order. We're doing our best to deliver it promptly for you.</p>",
    '🔁 Return policy': '🔁 Return policy',
    '<p>Please check our return/refund/exchange policy <a href="https://{{shopifyDomain}}/policies/refund-policy" rel="noopener noreferrer" target="_blank">here</a>.</p>':
      '<p>Please check our return/refund/exchange policy <a href="https://{{shopifyDomain}}/policies/refund-policy" rel="noopener noreferrer" target="_blank">here</a>.</p>'
  },
  'Show Navigation': {
    Home: 'Home',
    Message: 'Message',
    Track: 'Track',
    Help: 'Help',
    'Contact us title': 'Contact us',
    'Online status': 'We are online',
    'Online message': "Thank you for reaching out. We'll be with you in a moment",
    'Offline message':
      "Thanks for your message! We've received your contact details and will get back to you soon.",
    'Usually reply in a few minutes': 'Usually reply in a few minutes',
    'Usually reply in few hours': 'Usually reply in few hours',
    'Usually reply in a day': 'Usually reply in a day',
    'Order tracking title': 'Order tracking',
    'Track button': 'Track',
    'Article search placeholder': 'Search for help',
    'Categories title': 'Categories',
    '"View all" categories': 'View all',
    '"Article" singular label': 'Article',
    '"Article" plural label': 'Articles',
    'No matching article found': 'No matching article found',
    'No matching category found': 'No matching category found',
    'Heading title': 'Hi 👋',
    'Heading description': 'How can we help you?',
    'Welcome online message': 'Hi {{customer_name}} 👋\nHow can we help you?',
    'Welcome offline message':
      'Hi {{customer_name}} 👋\nWe are currently offline. We will respond as soon as possible during our next business hours.',
    'Welcome visitor teaser': 'Hi there 👋\nHow can we help you?',
    'Welcome message by chatbot':
      "Hello {{customer_name}} 👋 I'm Chatty AI assistant, here to help you find what you're looking for. How can I help you?",
    'First message by chatbot':
      'Hi {{customer_name}} 👋 Thanks for providing your contact information! How can I assist you today?',
      'Submit AI handover contact form':
      "You can submit below form to send directly to customer support's email urgently",
    'AI handover contact form button': 'Contact form',
    'AI handover contact form type us your problems': 'Type us your problems',
    'AI handover submit success':
      'Thanks for your submission. We have received your issue and will address it as soon as possible.',
    'Enter your email': 'Enter your email',
    'Launcher label': 'Chat with us',
    'Chat now': 'Chat now',
    'Type your message': 'Type your message',
    Emoji: 'Emoji',
    'Reply to': 'Reply to',
    Download: 'Download',
    Edit: 'Edit',
    Remove: 'Remove',
    'Replying to you': 'Replying to you',
    'Replying to yourself': 'Replying to yourself',
    'Replying to themselves': 'Replying to themselves',
    'Hi 👋, how can we help you?': 'Hi 👋, how can we help you?',
    'Please enter your email to stay updated with our replies':
      'Please enter your contact information so we can keep you updated with our replies',
    'Chat with us as anonymous': 'Chat with us as anonymous',
    'By sending us a message, you agree to our privacy policy':
      '<p>By sending us a message, you agree to our <a href="https://{{shopifyDomain}}/policies/privacy-policy" rel="noopener noreferrer" target="_blank">privacy policy</a>.</p>',
    Automated: 'Automated',
    '"Chat with us on your favorite channel" on Chat page': 'Chat with us on your favorite channel',
    "Thanks for your messages! We'll get back to you soon":
      "Thanks for your messages! We'll get back to you soon.",
    'Track your orders': 'Track your orders',
    'Cannot find any orders': 'Cannot find any orders.',
    'Order number': 'Order number',
    'Tracking number': 'Tracking number',
    'Email address': 'Email address',
    'Phone number': 'Phone number',
    'Last updated': 'Last updated',
    'Tracking information': 'Tracking information',
    'Shipping carrier': 'Shipping carrier',
    'Fulfilled date': 'Fulfilled date',
    Confirmed: 'Confirmed',
    items: 'items',
    Order: 'Order',
    'Need help': 'Need help',
    'Teaser message': "Don't miss out 👋\nDiscover your special offer waiting just for you!",
    'Invitation message': "Don't miss out 👋\nDiscover your special offer waiting just for you!",
    'Subscribe welcome': 'Subscribe to get hot deals, exclusive updates and rewards.',
    'Subscribe introduction': 'Subscribe now to get your offer!',
    'Subscribe success':
      'Thank you for subscribing! Check your inbox and stay tuned for the latest news and exclusive offers.',
    'Subscribed successfully': 'Subscribed successfully',
    'Check your email to confirm your subscription':
      'Check your email to confirm your subscription.',
    'Subscribed skipped': "You won't receive conversation history",
    'Subscribe button': 'Subscribe',
    'Back to chat': 'Back to chat',
    'Shop now': 'Shop now',
    Skip: 'Skip',
    Submit: 'Submit',
    'Tell us about your experience': 'Tell us about your experience',
    'Yes, sure': 'Yes, sure',
    'No, thanks': 'No, thanks',
    'Your coupon code': 'Your coupon code',
    more: 'more',
    'Attempted delivery': 'Attempted delivery',
    Delivered: 'Delivered',
    Canceled: 'Canceled',
    Delayed: 'Delayed',
    Failure: 'Failure',
    Fulfilled: 'Fulfilled',
    'In transit': 'In transit',
    'Label printed': 'Label printed',
    'Label purchased': 'Label purchased',
    'Label voided': 'Label voided',
    'Marked as fulfilled': 'Marked as fulfilled',
    'Not delivered': 'Not delivered',
    'Out for delivery': 'Out for delivery',
    'Ready for pickup': 'Ready for pickup',
    'Picked up': 'Picked up',
    Submitted: 'Submitted',
    Unfulfilled: 'Unfulfilled',
    'Partially fulfilled': 'Partially fulfilled',
    Restocked: 'Restocked',
    'Pending fulfillment': 'Pending fulfillment',
    Open: 'Open',
    'In progress': 'In progress',
    'On hold': 'On hold',
    Scheduled: 'Scheduled',
    'Request declined': 'Request declined',
    Returned: 'Returned',
    Refunded: 'Refunded',
    'Partially refunded': 'Partially refunded',
    Voided: 'Voided',
    'Order number is required': 'Order number is required',
    'Tracking number is required': 'Tracking number is required',
    'First name is required': 'First name is required',
    'Last name is required': 'Last name is required',
    'Email is required': 'Email is required',
    'Email is invalid': 'Email is invalid',
    'Phone number is required': 'Phone number is required',
    'Phone number is invalid': 'Phone number is invalid',
    'This field is required': 'This field is required',
    '"Track your order" on Track page': '"Track your order" on Track page',
    'Offline status message': 'Usually reply in a few minutes',
    'Order tracking placeholder': 'Order tracking',
    'Free shipping on all products • Applies to shipping rates under {{amount}}':
      'Free shipping on all products • Applies to shipping rates under {{amount}}',
    'Free shipping on all products': 'Free shipping on all products',
    'Free shipping on one-time purchase products • Applies to shipping rates under {{amount}}':
      'Free shipping on one-time purchase products • Applies to shipping rates under {{amount}}',
    'Free shipping on one-time purchase products': 'Free shipping on one-time purchase products',
    'Free shipping on subscription products': 'Free shipping on subscription products',
    'Free shipping on subscription products • Applies to shipping rates under {{amount}}':
      'Free shipping on subscription products • Applies to shipping rates under {{amount}}',

    '{{value}} off {{item}}': '{{value}} off {{item}}',
    '{{value}} off {{item}} • Minimum purchase of {{minimum}}':
      '{{value}} off {{item}} • Minimum purchase of {{minimum}}',
    '{{value}} off {{item}} • Minimum quantity of {{minimum}}':
      '{{value}} off {{item}} • Minimum quantity of {{minimum}}',
    '{{value}} off {{item}} collections • Minimum purchase of {{minimum}}':
      '{{value}} off {{item}} collections • Minimum purchase of {{minimum}}',
    '{{value}} off {{item}} collections': '{{value}} off {{item}} collections',
    '{{value}} off {{item}} products • Minimum purchase of {{minimum}}':
      '{{value}} off {{item}} products • Minimum purchase of {{minimum}}',
    '{{value}} off {{item}} products • Minimum quantity of {{minimum}}':
      '{{value}} off {{item}} products • Minimum quantity of {{minimum}}',
    '{{value}} off {{item}} products': '{{value}} of {{item}} products',
    '{{value}} off entire order • Minimum purchase of {{minimum}}':
      '{{value}} off entire order • Minimum purchase of {{minimum}}',
    '{{value}} off entire order • Minimum quantity of {{minimum}}':
      '{{value}} off entire order • Minimum quantity of {{minimum}}',
    '{{value}} off entire order': '{{value}} off entire order',

    '{{value}} off one-time purchase {{item}}': '{{value}} off one-time purchase {{item}}',
    '{{value}} off one-time purchase {{item}} • Minimum purchase of {{minimum}}':
      '{{value}} off one-time purchase {{item}} • Minimum purchase of {{minimum}}',
    '{{value}} off one-time purchase {{item}} • Minimum quantity of {{minimum}}':
      '{{value}} off one-time purchase {{item}} • Minimum quantity of {{minimum}}',
    '{{value}} off one-time purchase {{item}} collections • Minimum purchase of {{minimum}}':
      '{{value}} off one-time purchase {{item}} collections • Minimum purchase of {{minimum}}',
    '{{value}} off one-time purchase {{item}} collections':
      '{{value}} off one-time purchase {{item}} collections',
    '{{value}} off one-time purchase {{item}} products • Minimum purchase of {{minimum}}':
      '{{value}} off one-time purchase {{item}} products • Minimum purchase of {{minimum}}',
    '{{value}} off one-time purchase {{item}} products • Minimum quantity of {{minimum}}':
      '{{value}} off one-time purchase {{item}} products • Minimum quantity of {{minimum}}',
    '{{value}} off one-time purchase {{item}} products':
      '{{value}} of one-time purchase {{item}} products',
    '{{value}} off one-time purchase products': '{{value}} off one-time purchase products',
    '{{value}} off one-time purchase products in {{name}}':
      '{{value}} off one-time purchase products in {{name}}',

    '{{value}} off subscription {{item}}': '{{value}} off subscription {{item}}',
    '{{value}} off subscription {{item}} • Minimum purchase of {{minimum}}':
      '{{value}} off subscription {{item}} • Minimum purchase of {{minimum}}',
    '{{value}} off subscription {{item}} • Minimum quantity of {{minimum}}':
      '{{value}} off subscription {{item}} • Minimum quantity of {{minimum}}',
    '{{value}} off subscription {{item}} collections • Minimum purchase of {{minimum}}':
      '{{value}} off subscription {{item}} collections • Minimum purchase of {{minimum}}',
    '{{value}} off subscription {{item}} collections':
      '{{value}} off subscription {{item}} collections',
    '{{value}} off subscription {{item}} products • Minimum purchase of {{minimum}}':
      '{{value}} off subscription {{item}} products • Minimum purchase of {{minimum}}',
    '{{value}} off subscription {{item}} products • Minimum quantity of {{minimum}}':
      '{{value}} off subscription {{item}} products • Minimum quantity of {{minimum}}',
    '{{value}} off subscription {{item}} products': '{{value}} of subscription {{item}} products',
    '{{value}} off subscription products': '{{value}} off subscription products',
    '{{value}} off subscription products in {{name}}':
      '{{value}} off subscription products in {{name}}',

    'Buy {{buy}} item, get {{get}} item at {{discount}} off':
      'Buy {{buy}} item Get {{get}} item at {{discount}} off',
    'Buy {{buy}} item, get {{get}} item free': 'Buy {{buy}} item Get {{get}} item free',
    'Buy {{buy}} items, get {{get}} items at {{discount}} off':
      'Buy {{buy}} items Get {{get}} items at {{discount}} off',
    'Buy {{buy}} items, get {{get}} items free': 'Buy {{buy}} items Get {{get}} items free',
    'Buy {{buy}} item, get {{get}} items at {{discount}} off':
      'Buy {{buy}} item Get {{get}} items at {{discount}} off',
    'Buy {{buy}} item, get {{get}} items free': 'Buy {{buy}} item Get {{get}} items free',
    'Buy {{buy}} items, get {{get}} item at {{discount}} off':
      'Buy {{buy}} items Get {{get}} item at {{discount}} off',
    'Buy {{buy}} items, get {{get}} item free': 'Buy {{buy}} items Get {{get}} item free',

    'Spend {{buy}}, get {{get}} items at {{discount}} off':
      'Spend {{buy}}, get {{get}} items at {{discount}} off',
    'Spend {{buy}}, get {{get}} item at {{discount}} off':
      'Spend {{buy}}, get {{get}} items at {{discount}} off',
    'Spend {{buy}}, get {{get}} items free': 'Spend {{buy}}, get {{get}} items at free',
    'Spend {{buy}}, get {{get}} item free': 'Spend {{buy}}, get {{get}} item free',
    'Spend {{buy}}, get {{get}} items at {{discount}} off each':
      'Spend {{buy}}, get {{get}} items at {{discount}} off each',
    'Spend {{buy}}, get {{get}} item at {{discount}} off each':
      'Spend {{buy}}, get {{get}} item at {{discount}} off each',
    'Subscribe form introduction': 'Subscribe now to get your offer!',
    'Success message':
      'Thank you for subscribing! Check your inbox and stay tuned for the latest news and exclusive offers.',
    'Welcome message': 'Subscribe to get hot deals, exclusive updates and rewards.',
    'Conversation history subscribe message':
      'This conversation has been resolved. Send me conversation history.',
    'Automatically resolve conversation':
      "This chat was closed due to inactivity. Feel free to send a message to reopen it - we're here to help!",
    'Manually resolve conversation':
      "The conversation has been resolved. Feel free to send a message to reopen it - we're here to help!",
    'Satisfaction survey intro': 'How was your experience?',
    'Satisfaction survey feedback': 'Thank you for your feedback!',
    'Send me': 'Send me',
    Sent: 'Sent',
    "Yes, that's helpful!": "Yes, that's helpful!",
    'No, I need more help': 'No, I need more help',
    'I need more help': 'I need more help',
    "That's helpful": "That's helpful",
    'That answered my question': 'That answered my question',
    'All set, thanks!': 'All set, thanks!',
    'Talk to a person': 'Talk to a person',
    'Speak to an agent': 'Speak to an agent',
    'Need more help': 'Need more help',
    'Customer asks questions': 'Customer asks questions',
    'Bot answers based on knowledge base': 'Bot answers based on knowledge base',
    'Bot answers that there is no information': 'Bot answers that there is no information',
    'Continue with AI button': 'Continue with AI',
    'Your question has been transferred, a human agent will help you soon!':
      'Your question has been transferred. A human agent will help you soon!',
    Today: 'Today',
    Yesterday: 'Yesterday',
    'Last 7 days': 'Last 7 days',
    'Last 30 days': 'Last 30 days',
    'Last month': 'Last month',
    'Start chat': 'Start chat',
    'First name': 'First name',
    'Last name': 'Last name',
    'View product': 'View product',
    'View collection': 'View collection',
    'Get more help': 'Get more help',
    Thinking: 'Thinking',
    "I'm sorry, but I do not have information on that topic.":
      "I'm sorry, but I do not have information on that topic.",
    'Was it able to resolve your question?': 'Was it able to resolve your question?',
    'Glad I could help! Have a nice day! If you have any question, please feel free to contact us.':
      'Glad I could help! Have a nice day! If you have any question, please feel free to contact us.',
    'Please wait for a while, we need more information to check.':
      'Please wait for a while, we need more information to check.',
    'Reset conversation': 'Reset conversation',
    'Continue as email': 'Continue as email',
    'Click to reply': 'Click to reply',
    'Hi! Need help with this product?': 'Hi! Need help with this product?',
    'Close chatbox': 'Close chatbox',
    'Open chatbox': 'Open chatbox'
  }
};
